export default __webpack_public_path__ + "static/media/logo-halloween.405f4412.svg";